if (!customElements.get('routine-tabs-products')) {
    class RoutineTabsProducts extends HTMLElement {
        constructor() {
            super();
            this.buttons = this.querySelectorAll('[data-tab-button]');
            this.panels = this.querySelectorAll('[data-tab-panel]');
        }

        connectedCallback() {
            if (!this.buttons.length || !this.panels.length) return;

            this.buttons.forEach((button) => {
                button.addEventListener('click', () => {
                    this.switchTab(button.dataset.tabButton);
                });
            });
        }

        switchTab(handle) {
            this.buttons.forEach((button) => {
                const isActive = button.dataset.tabButton === handle;
                button.classList.toggle('is-active', isActive);
                button.setAttribute('aria-selected', isActive ? 'true' : 'false');
            });

            this.panels.forEach((panel) => {
                const isActive = panel.dataset.tabPanel === handle;
                panel.classList.toggle('is-active', isActive);

                if (isActive) {
                    panel.removeAttribute('hidden');
                } else {
                    panel.setAttribute('hidden', '');
                }
            });
        }
    }

    customElements.define('routine-tabs-products', RoutineTabsProducts);
}